import styled from '@emotion/styled';
import { InputBase, ToggleButton, ToggleButtonGroup } from '@mui/material';

import { FormField } from 'components/form/formField/formField';

export const StyledTimeInput = styled(InputBase)((props) => ({
  width: 40,
  height: 30,
  fontSize: 14,
  fontWeight: 500,
  textAlign: 'center',
  borderRadius: 5,
  color: props.theme.colors.text.primary,
  fontFamily: props.theme.fonts.primary,
  input: {
    textAlign: 'center',
    backgroundColor: props.theme.colors.container.primary,
    padding: 0,
    border: 'none',
    outline: 'none',
    borderRadius: 5,
    height: 32,
  },
  '& input:focus': {
    border: `1px solid ${props.theme.colors.accent}`,
  },
  '& input[aria-invalid=true]': {
    border: `1px solid ${props.theme.colors.error.main}`,
  },
}));

export const TimeColon = styled('span')((props) => ({
  fontSize: 18,
  fontWeight: 500,
  fontFamily: props.theme.fonts.primary,
  color: props.theme.colors.text.primary,
  lineHeight: '30px',
}));

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)({
  height: 32,
  borderRadius: 5,
});

export const StyledToggleButton = styled(ToggleButton)((props) => ({
  flex: 1,
  fontSize: 14,
  fontWeight: 500,
  fontFamily: props.theme.fonts.primary,
  color: props.theme.colors.inactive,
  '&.Mui-selected': {
    backgroundColor: props.theme.colors.lightBlue,
    color: props.theme.colors.secondary,
  },
  '&:not(:last-of-type)': {
    borderRight: '1px solid #ccc',
  },
}));

export const StyledFormField = styled(FormField)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  width: '100%',
}));
